require("babel-polyfill");
import Vue from 'vue'
import Vuex from 'vuex'
// import parts from modules
import searchMember from './modules/searchMember'
import searchClub from './modules/searchClub'
import searchOperations from './modules/searchOperations'
import general from './modules/general'
import storeApp from './store-app'
import storeMember from './store-member'
import storeClub from './store-club'
import storeSms from './store-sms'
import storeRanking from './store-ranking'
import storeRecap from './store-recap'
import storeFormation from './store-formation'
import storeCompetition from './store-competition'
import storeCompetitionPoomsae from './store-competition-poomsae'
import storeOrder from './store-order'
import stateLocalStorage from './local-storage'
import plugins from './plugins'
// Make vue aware of Vuex
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    storeApp,
    stateLocalStorage,
    storeMember,
    storeClub,
    storeRecap,
    storeRanking,
    storeSms,
    storeFormation,
    storeCompetition,
    storeCompetitionPoomsae,
    searchMember,
    searchClub,
    searchOperations,
    storeOrder,
    general,
  },
  plugins: plugins
})



// WEBPACK FOOTER //
// ./src/vuex/store.js